import React, { useState } from "react";
import { Button } from "react-bootstrap";  // Make sure to import Button from react-bootstrap
import { ReactTyped } from "react-typed";
const HeroSection = ({ title, description, imageSrc, buttonText, buttonVariant, buttonLink }) => {
  const [heroTitle] = useState(title || "Welcome to Our Hospital");
  const [heroDescription] = useState(
    description || "We provide top-notch medical services to ensure your health and well-being."
  );

  return (
    <div className="text-black">
      <div className="container">
        <div className="row align-items-center">
          {/* Text Content */}
          <div className="col-md-6 text-center text-md-left mb-md-0">
            <h1 className="text-6xl font-bold" style={{ color: "#093c60" }}>
              <ReactTyped
                strings={[
                  heroTitle,
                  "Your Health, Our Priority!",
                  "Caring for You Always!",
                ]}
                typeSpeed={100}
                backSpeed={60}
                loop
              />
            </h1>
            <p className="text-3xl font-bold" style={{ color: "#343a40" }}>
              {heroDescription}
            </p>
            {/* Dynamic Button */}
            {buttonText && (
              <Button
                variant={buttonVariant || "outline-info"}  
                href={buttonLink || "#"} style={{ marginBottom: "80px" }}
                className="px-4 font-bold "
              >
                {buttonText}
              </Button>
            )}
          </div>

          {/* Image Section as Background */}
          {/* <div className="col-md-6 text-center">
            {imageSrc && (
              <img
                src={imageSrc}
                alt="Hero"
                className="img-fluid rounded"
                style={{ maxHeight: "450px", marginTop: "50px" }}
              />
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
